import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import { getDeviceType } from './DigitalAnalyticsHelper';

export class TrackOrderActionFilter extends BaseActionFilter {
    trackOrderPageDL(store, data) {
        const { context } = store.getState();

        const deviceType = getDeviceType(context);

        const getTrackOrderDL = this.updateCommonDigitalData();
        getTrackOrderDL.page.pageInfo.pageName = data.pageName.toLowerCase();
        getTrackOrderDL.page.pageInfo.pageType = 'account';
        getTrackOrderDL.page.pageInfo.siteSection = 'account';
        getTrackOrderDL.page.pageInfo.deviceType = deviceType;
        getTrackOrderDL.page.pageInfo.searchRedirect = '';
        getTrackOrderDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        getTrackOrderDL.page.pageInfo.version = 'apollo 1 2017 redesign yoda account'; // TODO when we have multiple template
        getTrackOrderDL.page.category = {};
        getTrackOrderDL.page.category.primaryCategory = 'account';
        getTrackOrderDL.page.category.subCategory1 = '';
        getTrackOrderDL.page.category.subCategory2 = '';
        getTrackOrderDL.page.category.department = 'account';
        getTrackOrderDL.error = [];
        getTrackOrderDL.error.push({
            errorDescription: '',
        });
        return getTrackOrderDL;
    }
}

export default TrackOrderActionFilter;
